// React & Vendor Libs
const { render } = wp.element;
import { SWRConfig } from 'swr';

// Neko UI
import { jsonFetcher } from '@neko-ui';
import { Dashboard as CommonDashboard } from '@common';

// Components
import Settings from '@app/components/Settings';
import { DatabaseCleanerContextProvider } from './context';

const swrConfig = {
	fetcher: jsonFetcher,
	revalidateOnFocus: false
};

document.addEventListener('DOMContentLoaded', function(event) {

	// Settings
	const settings = document.getElementById('dbclnr-admin-settings');
	if (settings) {
		render((<SWRConfig value={swrConfig}><DatabaseCleanerContextProvider><Settings /></DatabaseCleanerContextProvider></SWRConfig>), settings);
	}

	// Common
	const meowDashboard = document.getElementById('meow-common-dashboard');
	if (meowDashboard) {
		render((<CommonDashboard />), meowDashboard);
	}

});
